import { useContext } from 'react';
import { I18nContext } from 'src/stores/I18n';
import styles from './index.module.scss';

type Props = {
  categoryName: string;
};

export const CategoryTitle: React.FC<Props> = ({ categoryName }) => {
  const localeResources = useContext(I18nContext);
  return (
    <h2 className={styles.title}>
      {categoryName} {localeResources.ranking.titleName}
    </h2>
  );
};
